/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S4_Li3Inputs */

const tr_onbilgi_s4_li3 = /** @type {(inputs: Onbilgi_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kart bilgileri Sağlayıcı tarafından saklanmaz; doğrudan ödeme kuruluşu altyapısı üzerinde işlenir.`)
};

const en_onbilgi_s4_li3 = /** @type {(inputs: Onbilgi_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Card details are not stored by the Provider; they are processed directly on the infrastructure of the payment institution.`)
};

const de_onbilgi_s4_li3 = /** @type {(inputs: Onbilgi_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartendaten werden vom Anbieter nicht gespeichert; sie werden unmittelbar in der Infrastruktur des Zahlungsinstituts verarbeitet.`)
};

const ru_onbilgi_s4_li3 = /** @type {(inputs: Onbilgi_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данные карты Поставщиком не хранятся; они обрабатываются непосредственно в инфраструктуре платёжной организации.`)
};

/**
* | output |
* | --- |
* | "Card details are not stored by the Provider; they are processed directly on the infrastructure of the payment institution." |
*
* @param {Onbilgi_S4_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s4_li3 = /** @type {((inputs?: Onbilgi_S4_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S4_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s4_li3(inputs)
	if (locale === "de") return de_onbilgi_s4_li3(inputs)
	if (locale === "ru") return ru_onbilgi_s4_li3(inputs)
	return tr_onbilgi_s4_li3(inputs)
});